import React from "react";
import { Loader2 } from "lucide-react";
import { Drawer, DrawerContent, DrawerHeader, DrawerTitle, DrawerDescription } from "../ui/drawer";

// Generic bottom-sheet used by every Professional Profile section editor (Sobre mí,
// Experiencia, Educación, Skills, Idiomas, Preferencias) — same pattern already used
// for CV Builder's "Ver etapas" and the Jobs mobile filters, reused here on purpose.
export function EditSectionDrawer({
  open, onOpenChange, title, saving,
  onSave, onDelete, deleteLabel, saveLabel, cancelLabel, children, onCancel, saveDisabled,
}) {
  return (
    <Drawer open={open} onOpenChange={onOpenChange}>
      <DrawerContent data-testid="profile-edit-drawer" className="sm:max-w-lg sm:mx-auto">
        <DrawerHeader>
          <DrawerTitle className="font-poppins">{title}</DrawerTitle>
          <DrawerDescription className="sr-only">{title}</DrawerDescription>
        </DrawerHeader>
        <div className="px-4 overflow-y-auto" style={{ maxHeight: "55vh" }}>
          <div className="space-y-4 pb-4">{children}</div>
        </div>
        <div className="flex gap-2 px-4 border-t border-[#E5E7EB] pt-3" style={{ paddingBottom: "calc(12px + env(safe-area-inset-bottom))" }}>
          {onDelete && (
            <button type="button" onClick={onDelete} data-testid="profile-drawer-delete-button" disabled={saving}
              style={{ height: "46px", padding: "0 16px", background: "white", color: "#EF4444", border: "1px solid #FEE2E2", borderRadius: "10px", fontSize: "14px", fontWeight: 600, fontFamily: "Poppins, sans-serif", cursor: "pointer", flexShrink: 0 }}>
              {deleteLabel}
            </button>
          )}
          <button type="button" onClick={() => (onCancel ? onCancel() : onOpenChange(false))} data-testid="profile-drawer-cancel-button" disabled={saving}
            style={{ flex: 1, height: "46px", background: "white", color: "#64748B", border: "1px solid #E5E7EB", borderRadius: "10px", fontSize: "14px", fontWeight: 600, fontFamily: "Poppins, sans-serif", cursor: "pointer" }}>
            {cancelLabel}
          </button>
          <button type="button" onClick={onSave} data-testid="profile-drawer-save-button" disabled={saving || saveDisabled}
            style={{ flex: 1, height: "46px", background: "#028CF8", color: "white", border: "none", borderRadius: "10px", fontSize: "14px", fontWeight: 700, fontFamily: "Poppins, sans-serif", cursor: saveDisabled ? "not-allowed" : "pointer", opacity: saving || saveDisabled ? 0.6 : 1, display: "flex", alignItems: "center", justifyContent: "center", gap: "6px" }}>
            {saving && <Loader2 className="h-4 w-4 animate-spin" />} {saveLabel}
          </button>
        </div>
      </DrawerContent>
    </Drawer>
  );
}
